import checks from './checks';
import ResizeObserver from 'resize-observer-polyfill';

const classChange = (obj, width, target, prefix = '') => {
  Object.keys(obj).forEach(w => {
    if (obj[w] <= width) {
      target.classList.add(prefix + w);
    } else {
      target.classList.remove(prefix + w);
    }
  });
};

const defaultBps = {
  width: {
    xxs: 256,
    xs: 512,
    sm: 768,
    md: 1024,
    lg: 1280,
    xl: 1536,
    xxl: 1792
  }
};

export const ro = (dbps = defaultBps) => {
  return new ResizeObserver(entries => {
    for (const entry of entries) {
      const { 
        left,
        height,
        top,
        width 
      } = entry.contentRect;

      const customBps = entry.target.dataset.wurldsobps ? JSON.parse(entry.target.dataset.wurldsobps) : {};
      const bps = {
        ...dbps,
        ...customBps
      };

      if (checks.isObject()(bps.width)) {
        classChange(bps.width, width, entry.target);
      }
      if (entry.target.dataset.wurldsoheight) {
        if (checks.isObject()(bps.height)) {
          classChange(bps.height, height, entry.target);
        } else if (checks.isObject()(bps.width)) {
          classChange(bps.width, height, entry.target, 'h-');
        }
      }
      if (entry.target.dataset.wurldsotop) {
        if (checks.isObject()(bps.top)) {
          classChange(bps.top, top, entry.target);
        }
      }
      if (entry.target.dataset.wurldsoleft) {
        if (checks.isObject()(bps.left)) {
          classChange(bps.left, left, entry.target);
        }
      }
    }
  })
};